//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  IconButton,
  Tooltip,
} from '@mui/material';
import { Add } from '@mui/icons-material';

// === COMPONENTS ===
import { Spacer            } from 'components/Spacer.jsx';
import { Expression        } from '../ExpressionView/components/Expression/Expression';
import { ExpressionContext } from '../ExpressionContext/ExpressionContext';

// === API ===

// === UTILS ===
import { getHexAlpha } from 'components/styles.utils';

//#endregion

//-----------------------------------------------------------------
export function PredicateView() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const { predicates, createPredicate } = useContext( ExpressionContext );

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      gridColumn    : 1,
      gridRow       : 2,
      height        : '100%'   ,
      minWidth      : '60rem'  ,
      maxWidth      : '70rem'  ,
      borderRadius  : '1rem'   ,
      overflow      : 'hidden' ,
      padding       : '1rem'   , 
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    container_exp: {
      height       : 'calc( 100% - 4rem )' ,
      width        : '100%'   ,
      overflow     : 'hidden' , 
      borderRadius : '1rem'   ,
    },
    container_exp_2: {
      width        : '100%' ,
      height       : 'max-content' ,
      maxHeight    : '100%',
      overflow     : 'auto' ,
      borderRadius : '1rem'   ,
      padding      : '0.5rem', 
      paddingBottom: '0rem',
      backgroundColor: theme.palette.primary[theme.palette.mode],
      scrollbarColor: `${theme.palette.secondary.main+getHexAlpha(50)} ${theme.palette.background.primary[theme.palette.mode]}`,
      scrollbarWidth: 'thin',
    },
    header: {
      fontSize: '2rem',
    },
    border_1: {
      display: 'flex',
      borderRadius: '1rem',
      width: '100%',
    },
    button_add: {
      backgroundColor: theme.palette.primary[theme.palette.mode],
      color: 'white',
    },
    button_toggle: {
      backgroundColor: theme.palette.primary[theme.palette.mode],
      color: 'white',
    },
  }

  const CONTAINER = {
    style: _styles.container,
  };
  const CONTAINER_EXP = {
    style: _styles.container_exp,
  };
  const CONTAINER_EXP_2 = {
    style: _styles.container_exp_2,
  };
  const HEADER = {
    style: _styles.header,
    children: 'Predicate:',
  };
  const BORDER_1 = {
    style: _styles.border_1,
  };
  const BUTTON_ADD = {
    sx: _styles.button_add,
    children: <Add />,
    onClick: onClick_Add,
  };
    
  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [MODIFY]

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick_Add() {
    //-----------------------------------------------------------------
    createPredicate();
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div { ...CONTAINER } >
        <div { ...BORDER_1 } >
          <div { ...HEADER } />
          <Spacer fill />
          <Tooltip title='Add item' placement='top'>
            <IconButton { ...BUTTON_ADD  } />
          </Tooltip>
        </div>
        <Spacer />
        { displayExpressions() }
      </div>
    );
  }

  //-----------------------------------------------------------------
  function displayExpressions() {
    //-----------------------------------------------------------------
    const comps = predicates.map( exp => {
      return (
        <React.Fragment key={exp.id}>
          <Expression key={exp.id} data={exp} is_predicate />
          <Spacer size='0.5rem' />
        </React.Fragment>
      )
    });
    return (
      <div { ...CONTAINER_EXP } >
        <div { ...CONTAINER_EXP_2 } >
          {comps}
        </div>
      </div>
    )
  }

  //#endregion

  return display();
}
